
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vvxn7_6ke8z_94",
  "grid": "awsui_grid_vvxn7_6ke8z_105",
  "grid-no-gutters": "awsui_grid-no-gutters_vvxn7_6ke8z_110",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vvxn7_6ke8z_113",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vvxn7_6ke8z_120",
  "grid-columns-1": "awsui_grid-columns-1_vvxn7_6ke8z_123",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vvxn7_6ke8z_123",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vvxn7_6ke8z_126",
  "grid-columns-2": "awsui_grid-columns-2_vvxn7_6ke8z_129",
  "grid-columns-3": "awsui_grid-columns-3_vvxn7_6ke8z_135",
  "grid-columns-4": "awsui_grid-columns-4_vvxn7_6ke8z_141",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vvxn7_6ke8z_154",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vvxn7_6ke8z_187"
};
  